import { formatCurrency, formatPercent } from 'common/utils/trading-demo';
import { PortfolioInfoType } from 'service/trading-demo';

const QuickStats = ({
  portfolioData,
}: {
  portfolioData: PortfolioInfoType;
}) => {
  const quickStats = [
    {
      label: '勝率',
      value: formatPercent({
        value: portfolioData?.data?.summary?.win_rate,
        supportZero: false,
        withSign: false,
      }),
    },
    {
      label: '総取引回数',
      value: portfolioData?.data?.summary?.total_trades?.toString() || '0',
    },
    {
      label: '実現損益',
      value: formatCurrency({
        value: portfolioData?.data?.summary?.total_realized_pnl,
        supportZero: true,
        withSign: true,
        currency: 'JPY',
      }),
    },
  ];

  return (
    <div className="rounded-2xl bg-white p-4 shadow-sm">
      <h3 className="mb-4 text-sm font-semibold text-pp-text-primary">
        勝敗情報
      </h3>
      <div className="space-y-3">
        {quickStats.map((stat) => (
          <div
            key={stat.label}
            className="flex items-center justify-between py-1.5"
          >
            <span className="text-xs text-pp-text-secondary">{stat.label}</span>
            <span className="text-sm font-semibold text-pp-text-primary">
              {stat.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuickStats;
